<template>
  <div class="action-float-left mx-1">
    <vx-tooltip :text="tooltip">
        <feather-icon
        @click="this.export"
        :icon="icon"
        svgClasses="h-5 w-5 hover:text-primary cursor-pointer action-block"
        />
    </vx-tooltip>
  </div>
</template>

<script>
import {URL_CUSTOM_REPORT} from '@/urls.js'

export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    type:{
      type:String
    },
    data:{
      type:Object
    }
  },
  methods: {
    export() {
        let request = this.buildReport(this.type)
        let new_url = URL_CUSTOM_REPORT + request
        window.open(new_url)
    },
    buildReport(type){
      let request = `${type}/0?`
      Object.keys(this.data).forEach(key => {
        if (this.data[key] != undefined) {
          request += `&${key}=${this.data[key]}`
        }
      });
      
      return request;
    }
  }
}
</script>

<style>
</style>